import { AWS_BASE_URL, R2_PUBLIC_URL } from "./Constants";

/**
 * Frontend helper for dual-backend assessment object URLs (Admin).
 *
 * Provider flags (same as DB fileUploadedFrom / feedbackUploadedFrom):
 *   0 / null / "" = local/legacy path (return path as-is)
 *   1             = AWS S3 (prepend S3 / legacy AWS public base URL)
 *   2             = Cloudflare R2 (prepend R2 public base URL)
 *
 * REACT_APP_* values are baked in at frontend start — restart after env changes.
 */

/** Trim spaces/quotes from .env values like REACT_APP_R2_PUBLIC_URL = "https://..." */
const cleanEnvUrl = (value) => {
  if (!value) return "";
  return String(value)
    .trim()
    .replace(/^['"]|['"]$/g, "");
};

// AWS S3 public base (legacy AWS_BASE_URL / REACT_APP_S3_PUBLIC_URL)
const S3_PUBLIC_URL = cleanEnvUrl(
  process.env.REACT_APP_S3_PUBLIC_URL || AWS_BASE_URL || ""
);


/** Ensure base URL ends with "/" before concatenating an object key. */
const ensureTrailingSlash = (url) => {
  if (!url) return "";
  return url.endsWith("/") ? url : `${url}/`;
};

/**
 * Resolve a browser-fetchable URL for an assessment object key.
 *
 * @param {string} path - Object key or absolute URL
 * @param {string|number|null|undefined} fileUploadedFrom - Storage provider flag
 * @returns {string} Absolute or relative URL safe to open/download in the browser
 */
export const resolveObjectStorageUrl = (path, fileUploadedFrom) => {
  if (!path) return "";

  // Already absolute — do not rewrite
  if (/^(?:https?:)?\/\//i.test(path)) {
    return path;
  }
  const provider = String(
    fileUploadedFrom === null || fileUploadedFrom === undefined
      ? ""
      : fileUploadedFrom
  );

  // Cloudflare R2 (new uploads)
  if (provider === "2") {
    console.log("R2_PUBLIC_URL", R2_PUBLIC_URL);
    if (!R2_PUBLIC_URL) {
      console.warn(
        "[objectStorage] REACT_APP_R2_PUBLIC_URL is empty — set it in front/.env.local and restart Admin UI"
      );
      return "";
    }
    console.log("returnURL", `${ensureTrailingSlash(R2_PUBLIC_URL)}${path}`);
    return `${ensureTrailingSlash(R2_PUBLIC_URL)}${path}`;
  }

  // AWS S3 (existing files)
  if (provider === "1") {
    return `${ensureTrailingSlash(S3_PUBLIC_URL)}${path}`;
  }

  // Local / legacy: use path unchanged
  return path;
};

/** True when URL should open/download directly (skip corona proxy). */
export const isObjectStorageHttpUrl = (url) => /^https?:\/\//i.test(url || "");
